export default __webpack_public_path__ + "static/media/ic_uni_40.45c0523a.svg";